import "./cellUnit.css";

export type GenericCellProps = {
  value: string;
};

const GenericCell: React.FC<GenericCellProps> = ({ value }) => {
  return (
    <div className="cell-unit">
      <div className="overlay"></div>

      <span className="body-medium">{value}</span>
    </div>
  );
};

export default GenericCell;
